<div>
    <app-tooltip *ngIf="path"
                 class="tooltip"
                 type="info"
                 [record]="fullPath">
    </app-tooltip>
    <span [class.placeholder]="!path"
          [class.path]="path">
          {{path ? path : placeholder}}
    </span>
    <i class="fa"
        [class.fa-cloud-upload]="!download"
        [class.fa-cloud-download]="download">
    </i>
</div>
